import { IVoucherLimitState } from "@saleor/discounts/hooks/useVoucherLimitsData";
import {
  DiscountDeliveryTypeEnum,
  DiscountValueTypeEnum,
  VoucherClassificationEnum,
  VoucherTypeEnum
} from "@saleor/types/globalTypes";
export const runVoucherValidation = (
  initialForm,
  voucherMaxDiscountValue,
  voucherLimitState: IVoucherLimitState
) => {
  const {
    code,
    deliveryType,
    description,
    endDate,
    endTime,
    hasMinTenants,
    hasUsageLimit,
    startDate,
    startTime,
    maxDiscountValue,
    minCheckoutItemsQuantity,
    minSpent,
    minTenants,
    discountType,
    smopDiscountShare,
    tenantDiscountShare,
    type,
    requirementsPicker,
    usageLimit,
    value,
    verticalType,
    bulkCreate
  } = initialForm;

  const numbers = /^[.0-9]+$/;
  const space = /\s/g;
  const distributionTotal = Math.round(
    Number(smopDiscountShare) + Number(tenantDiscountShare)
  );

  const codeMessage = () => {
    if (code === null || code === "") {
      return "This field is required";
    }
    if (space.test(code)) {
      return "Please enter voucher code without spaces";
    }
    if (code.length > 16 && bulkCreate === true) {
      return "Bulk voucher codes should not exceed 16 characters";
    }
    if (code.length > 20) {
      return "Voucher code should not exceed 20 characters";
    }
    return null;
  };
  const descriptionMessage = () => {
    if (description?.length > 700) {
      return "Maximum of 700 characters.";
    }
    return null;
  };
  const startDateMessage = () => {
    if (startDate === "" || startDate === null) {
      return "This field is required.";
    }
    return null;
  };

  const startTimeMessage = () => {
    if (startTime === "" || startTime === null) {
      return "This field is required.";
    }
    return null;
  };

  const endDateMessage = () => {
    if (endDate === "" || endDate === null) {
      return "This field is required.";
    }
    return null;
  };

  const endTimeMessage = () => {
    if (endTime === "" || endTime === null) {
      return "This field is required.";
    }
    return null;
  };

  const hasVoucherConditionsMessage = () => {
    if (
      voucherLimitState.isLimitToCustomerActivity &&
      !voucherLimitState.isWithOngoingOrders &&
      !voucherLimitState.isWithSwipeCoupons
    ) {
      return "Choose at least one item from the Limit to Customer Activity.";
    }
    return null;
  };

  const minCheckoutItemsQuantityMessage = () => {
    if (requirementsPicker === "ITEM") {
      if (
        minCheckoutItemsQuantity &&
        !String(minCheckoutItemsQuantity).match(numbers)
      ) {
        return "Allow number only";
      }
    }

    return null;
  };
  const minSpentMessage = () => {
    if (requirementsPicker === "ORDER") {
      if (minSpent && !String(minSpent).match(numbers)) {
        return "Allow number only";
      }
    }

    return null;
  };
  const percentageMessage = () => {
    if (discountType === DiscountValueTypeEnum.PERCENTAGE && value) {
      if (value > 100) {
        return "Percentage value is equals or below 100%";
      }
      if (!String(value).match(numbers)) {
        return "Allow number only";
      }
    }
    if (discountType === DiscountValueTypeEnum.FIXED && value) {
      if (!String(value).match(numbers)) {
        return "Allow number only";
      }
    }
    if (discountType === "PERCENTAGE_AND_CAPPED" && value) {
      if (value > 100) {
        return "Percentage value is equals or below 100%";
      }
      if (!String(value).match(numbers)) {
        return "Allow number only";
      }
    }

    return null;
  };

  const maxDiscountValueMessage = () => {
    if (discountType === "PERCENTAGE_AND_CAPPED") {
      if (!String(maxDiscountValue).match(numbers)) {
        return "Allow number only";
      }
      if (maxDiscountValue === 0 || maxDiscountValue === "0") {
        return "Must be greater than 0";
      }
    }

    if (voucherMaxDiscountValue) {
      if (!String(maxDiscountValue).match(numbers)) {
        return "Allow number only";
      }
      if (maxDiscountValue === 0 || maxDiscountValue === "0") {
        return "Must be greater than 0";
      }
    }

    return null;
  };
  const smopDiscountShareMessage = () => {
    if (
      (discountType === "PERCENTAGE_AND_CAPPED" && type !== "SHIPPING") ||
      (discountType === DiscountValueTypeEnum.PERCENTAGE &&
        type !== "SHIPPING") ||
      (voucherMaxDiscountValue && type !== "SHIPPING") ||
      (discountType === DiscountValueTypeEnum.FIXED && type !== "SHIPPING")
    ) {
      if (smopDiscountShare === "" || smopDiscountShare === null) {
        return "This field is required.";
      }

      if (isNaN(smopDiscountShare)) {
        return "Allow number only";
      }
    }
    return null;
  };

  const tenantDiscountShareMessage = () => {
    if (
      (discountType === "PERCENTAGE_AND_CAPPED" && type !== "SHIPPING") ||
      (discountType === DiscountValueTypeEnum.PERCENTAGE &&
        type !== "SHIPPING") ||
      (voucherMaxDiscountValue && type !== "SHIPPING") ||
      (discountType === DiscountValueTypeEnum.FIXED && type !== "SHIPPING")
    ) {
      if (tenantDiscountShare === "" || tenantDiscountShare === null) {
        return "This field is required.";
      }
      if (isNaN(tenantDiscountShare) && type !== "SHIPPING") {
        return "Allow number only";
      }
    }

    return null;
  };

  const distributionMessage = () => {
    if (type === VoucherTypeEnum.SPECIFIC_PRODUCT) {
      return null;
    }
    if (
      (discountType === "PERCENTAGE_AND_CAPPED" && type !== "SHIPPING") ||
      (discountType === DiscountValueTypeEnum.PERCENTAGE &&
        type !== "SHIPPING") ||
      (voucherMaxDiscountValue && type !== "SHIPPING") ||
      (discountType === DiscountValueTypeEnum.FIXED &&
        type !== "SHIPPING" &&
        type !== "E_VOUCHER")
    ) {
      if (distributionTotal !== 100) {
        return "The sum of tenant and discount share should be equal to  100%";
      }
    }
    // if (
    //   (discountType === "E_VOUCHER" && type !== "SHIPPING")
    // ) {
    //   if (distributionTotal !== Number(value)) {
    //     return "The discount distribution should be equal to voucher value";
    //   }
    // }

    return null;
  };

  const usageLimitMessage = () => {
    if (hasUsageLimit) {
      if (!String(usageLimit).match(numbers)) {
        return "This field is required";
      } else if (usageLimit <= 0) {
        return "This field is required";
      }
    }

    return null;
  };

  const minTenantsMessage = () => {
    if (
      hasMinTenants &&
      verticalType === VoucherClassificationEnum.FOOD_AND_BEVERAGES &&
      deliveryType === DiscountDeliveryTypeEnum.EXPRESS_DELIVERY &&
      minTenants > 3
    ) {
      return "Express delivery maximum tenants must not exceed 3.";
    }
    return null;
  };

  const deliveryTypeMessage = () => {
    if (discountType === "E_VOUCHER") {
      return null;
    }
    if (deliveryType.length === 0) {
      return "This field is required";
    }
    return null;
  };
  return {
    code: codeMessage(),
    deliveryType: deliveryTypeMessage(),
    description: descriptionMessage(),
    distribution: distributionMessage(),
    endDate: endDateMessage(),
    endTime: endTimeMessage(),
    hasVoucherConditions: hasVoucherConditionsMessage(),
    maxDiscountValue: maxDiscountValueMessage(),
    minCheckoutItemsQuantity: minCheckoutItemsQuantityMessage(),
    minSpent: minSpentMessage(),
    minTenants: minTenantsMessage(),
    smopDiscountShare: smopDiscountShareMessage(),
    startDate: startDateMessage(),
    startTime: startTimeMessage(),
    tenantDiscountShare: tenantDiscountShareMessage(),
    usageLimit: usageLimitMessage(),
    value: percentageMessage()
  };
};

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
